/**
 * Logging Levels
 * In order (lowest to highest): TRACE, DEBUG, INFO, LOG, WARN, ERROR
 * @export
 * @enum {number}
 */
export var LogLevel;
(function (LogLevel) {
    LogLevel[LogLevel["TRACE"] = 0] = "TRACE";
    LogLevel[LogLevel["DEBUG"] = 1] = "DEBUG";
    LogLevel[LogLevel["INFO"] = 2] = "INFO";
    LogLevel[LogLevel["LOG"] = 3] = "LOG";
    LogLevel[LogLevel["WARN"] = 4] = "WARN";
    LogLevel[LogLevel["ERROR"] = 5] = "ERROR";
})(LogLevel || (LogLevel = {}));
export class LoggerConfig {
    /**
     * The minimum logging level for logging to console
     *
     * @static
     * @type {LogLevel}
     * @memberof LoggerService
     */
    static { this.LocalLogLevel = LogLevel.LOG; }
    /**
     * The minimum logging level for logging to the server (eg. New Relic)
     *
     * @static
     * @type {LogLevel}
     * @memberof LoggerService
     */
    static { this.ServerLogLevel = LogLevel.LOG; }
}
function setDebugLogLevel(type, enabled, metadata) {
    const capMetadata = metadata.toUpperCase();
    if (enabled && LogLevel[capMetadata] > -1) {
        LoggerConfig[type] = LogLevel[capMetadata];
    }
    else {
        LoggerConfig[type] = LogLevel.LOG;
    }
}
export function setLocalLogLevel(enabled, metadata = '') {
    setDebugLogLevel('LocalLogLevel', enabled, metadata);
}
export function setServerLogLevel(enabled, metadata = '') {
    setDebugLogLevel('ServerLogLevel', enabled, metadata);
}
// Debug Flag
export const LOG_ALL_STORE_ACTIONS_FLAG = [
    {
        name: 'local_log_level',
        hasMetadata: true,
        metadataHint: 'Error, Warn, Log, Info, Debug, Trace (Default: Log)',
        onChange: setLocalLogLevel
    },
    {
        name: 'server_log_level',
        hasMetadata: true,
        metadataHint: 'Error, Warn, Log, Info, Debug, Trace (Default: Log)',
        onChange: setServerLogLevel
    }
];
//# sourceMappingURL=logger-config.js.map